import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import MessageOutgoingActions from '../../redux/reducers/message_outgoing_reducer/actions';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import { TableDefaultFetchValues, Translations } from './configuration';
import MessageOutgoingViewModal from './components/datatable/view';
import useQuery from 'custom_hooks/useQuery';
import { parseQueryDate } from '../../utils/dates';

const MessageOutgoingPage = (props: any) => {
  // console.log('Render MessageOutgoingPage');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const messageId = query.get('messageId');
  const destinationCountry = query.get('destinationCountry');
  const messageType = query.get('messageType');
  const status = query.get('status');
  const date_from = query.get('date_from');
  const date_to = query.get('date_to');
  let searchParams = {
    ...(messageId && { messageId }),
    ...(destinationCountry && { destinationCountry }),
    ...(messageType && { messageType }),
    ...(status && { status }),
    ...(date_from && { date_from: parseQueryDate(date_from) }),
    ...(date_to && { date_to: parseQueryDate(date_to) }),
  };

  React.useEffect(() => {
    dispatch(MessageOutgoingActions.fetchMemberStateExcludeCyprusAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      MessageOutgoingActions.fetchMessageOutgoingAction({
        sortField: TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize: TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    <div>
      <MessageOutgoingViewModal />
      <Paper
        className={clsx(classes.cardLayout, classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <Box display="flex" alignItems={'center'}>
          <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      <div style={{ padding: 12 }}>
        <DatatableList />
      </div>
    </div>
  );
};

export default withRouter(MessageOutgoingPage);
